exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".address-book .address-wrap[data-v-64024157] {\n  margin: 1.2em 0em;\n}\n", ""]);

// exports
